import { Component, input } from '@angular/core';
import { SelectionButtonComponent } from '@shared/components/challenges/elements/selection-button/selection-button.component';
import { UnselectionButtonComponent } from '@shared/components/challenges/elements/unselection-button/unselection-button.component';
import { WinCardComponent } from '@shared/components/challenges/elements/win-card/win-card.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { CampaignPhase } from '@shared/constants';
import { FrequencyChallenge } from '@shared/factory';
import { FrequencyChallengeSixthVariantConfig } from '@shared/models';
import {
  SafePipe,
  TransformUrlToBgPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

import { FrequencyBaseClass } from '../frequency.base.class';

@Component({
  selector: 'b2c-variant6',
  styleUrl: './variant6.component.scss',
  templateUrl: './variant6.component.html',
  imports: [
    SafePipe,
    IconComponent,
    WinCardComponent,
    TransformUrlToBgPipe,
    VariableReplacementPipe,
    SelectionButtonComponent,
    UnselectionButtonComponent,
  ],
})
export class Variant6Component extends FrequencyBaseClass {
  /**
   * Render the card the way a shopper sees it once the challenge is selected —
   * its steps on show — while the challenge is in fact still unselected, and
   * drop the selection button. Set by the onboarding swipe deck, where the
   * deck's own pass/select buttons and the swipe gesture do the selecting.
   */
  previewSelected = input<boolean>(false);

  challenge = input.required<FrequencyChallenge>();
  config = input.required<FrequencyChallengeSixthVariantConfig>();

  withShadow = input<boolean>(true);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);
}
